import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyRevenueByState.';
  public static readonly monthlyGeneratedRevenue = `${Id.prefix}monthlyGeneratedRevenue`;
  public static readonly order = `${Id.prefix}order`;
  public static readonly quote = `${Id.prefix}quote`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDashboardBranchMonthlyRevenueByState {
  private constructor() {}
  public static monthlyGeneratedRevenue(params: { state: string }): string {
    return interpolate(Id.monthlyGeneratedRevenue, params);
  }
}

export class DashboardBranchMonthlyRevenueByStateModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.monthlyGeneratedRevenue,
      'Monthly Generated Revenue {{state}}',
      'Header for monthly generated revenue widget, with quote state'
    );
  }
}
